<template>
  <div>
    <div class="container contprofile py-5">
      <div class="row">
        <div id="payment" class="col-md-6 col-lg-8 m-auto">
          <div class="row">
            <div class="col-md-4 d-none d-md-block">
              <img
                class="img-fluid"
                src="../../../assets/img/payment/Rectangle.png"
                alt="logo"
                style="width: 100%"
              />
            </div>
            <div class="col-md form">
              <h6 class="userTitle">پرداخت به کاروام</h6>
              <div class="userForm">
                <div class="form-row moneyPayment">
                  <label>ورود مبلغ دلخواه</label>
                  <input
                    v-model="model.price"
                    type="text"
                    class="form-control"
                  />
                  <em class="text-right"> {{formatNumber( model.price) }} تومان</em>
                  <em class="text">  ({{ model.price.num2persian() }} )</em>
                  <div v-for="(item, index) in error.price" :key="index">
                    <span class="message-error">{{ item }}</span> 
                  </div>
                </div>
                <div class="form-row" v-if="model.donation == 'false'">
                  <date-picker
                    clearable
                    class="w-100 mt-2"
                    placeholder="تاریخ بازگشت وجه"
                    v-model="model.refund_date"
                  />
                </div>
                <div class="form-row mt-4">
                  <div class="form-check">
                    <input
                      class="form-check-input mr-3"
                      type="radio"
                      id="exampleRadios1"
                      v-model="model.donation"
                      value="true"
                      checked
                    />
                    <label class="form-check-label" for="exampleRadios1">
                      این مبلغ را به صورت بلاعوض اهدا میکنم
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input mr-3"
                      type="radio"
                      id="exampleRadios2"
                      v-model="model.donation"
                      value="false"
                    />
                    <label class="form-check-label" for="exampleRadios2">
                      این مبلغ را به صورت قرض الحسنه پرداخت میکنم
                    </label>
                  </div>
                </div>
                <div class="form-row mb-5" style="flex-flow: nowrap">
                  <input
                    type="checkbox"
                    class="form-control mr-3"
                    style="width: 21px"
                    v-model="model.anonymouse"
                  />
                  <label class="mt-2" for="">
                    پرداخت به صورت ناشناس و ما نام و نام خانوادگی پرداخت کننده
                    را افشا نمیکنیم
                  </label>
                </div>
                <div class="form-group mt-5">
                  <div class="userBtn">
                    <router-link to="/profile/Dashboard" class="userBtnCancel"
                      >بازگشت به پروفایل
                    </router-link>
                    <button
                      type="button"
                      v-on:click="Submit()"
                      class="userBtnSend"
                    >
                      پرداخت
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model: {
        price: 0,
        refund_date: "",
        donation: true,
        anonymouse: false,
      },
      error: {
        price: [],
      },
    };
  },
  created() {
    this.$http.get("user/info?get=id").then(
      (response) => {
        if (response.status == 200) {
          this.model.id = response.body.data.id;
        } else {
          this.error.price = response.body.data.errors.price;
        }
      },
      (data) => {
        if (data.status == 200) {
          this.model.id = data.body.data.id;
        } else {
          this.error.price = data.body.data.errors.price;
        }
      }
    );
  },
  methods: {
    Submit() {
      this.$http.post("pay/karvam", this.model).then(
        (response) => {
          console.log('pay/karvam - response:' ,response.body);
          window.location.href =  response.body;
          
          // if (response.status == 200) {
          //   this.SendPay(response.body.params);
          // }
        },
        (data) => {
          console.log('pay/karvam - data:',data);
          window.location.href =  data.body;
          // if (data.status == 200) {
          //   this.SendPay(data.body.params);
          // }
        }
      );
    },
    formatNumber(value) {
      if (value < 0) {
        value = 0;
      }
      let val = value / 1;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    SendPay(params) {
      this.$http.post("https://rt.sizpay.ir/Route/Payment", params).then(
        (response) => {
          console.log(response);
          if (response.status == 200) {
            this.id = response.body.data.id;
          }
        },
        (data) => {
          console.log(data);
          if (data.status == 200) {
            this.id = data.body.data.id;
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.contprofile {
  margin-top: 130px;
}
a {
  text-decoration: none;
}

ul li {
  list-style: none;
}

#payment {
  background: #ffffff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  .form {
    padding: 10px;
  }
}

.userTitle {
  font-weight: bold;
  margin: 25px auto;
}

.userForm {
  .form-row {
    margin-bottom: 0.5rem;
    padding: 0 15px;
  }
  .moneyPayment {
    position: relative;
    width: 98%;
    padding: 0 5px;
    margin: auto;
    label {
      width: 40%;
      font-size: 14px;
      display: flex;
      align-items: center;
      color: #ffffff;
      background: #3bcf93;
      border-radius: 0 5px 5px 0;
      height: 50px;
      font-weight: 700;
      padding: 0 7%;
    }
    input {
      width: 60%;
      display: inline-block;
      text-align: left;
      border-radius: 5px 0 0 5px !important;
      color: #3bcf93;
      font-size: 18px !important;
      font-weight: 700 !important;
    }
    em {
      width: 100%;
    text-align: left;
    float: left;
    margin-left: 1rem;
    font-size: small;
    margin-top: -.75rem;
    
    }
    em.text{
      font-size: xx-small;
      margin-top: 0rem;
    }
  }
  input[type="text"],
  input[type="number"],
  input[type="email"],
  select,
  textarea {
    font-size: 14px;
    line-height: 22px;
    font-style: normal;
    font-weight: 600;
    height: 50px;
    margin-bottom: 15px;
    border-radius: 5px;
    background-color: #f1f1f1;

    &:hover {
      border: 2px solid #4d5dd4;
      border-radius: 0;
    }

    &::placeholder {
      color: #9e9e9e;
      font-weight: 400;
    }
  }
 /* input[type="radio"] {
    // height: 70px;
  }*/
  textarea {
    height: 100px;
  }
  .userLable {
    color: #9e9e9e;
    background-color: #f1f1f1;
    padding: 15px 40px;
    border-radius: 5px;
  }
  .userBtn {
    float: left;
    margin-top: 2.5rem;
    margin-left: 2rem;
  }
  .userBtnSend {
    color: #fff;
    background-color: #3bcf93;
    border: none;
    border-radius: 5px;
    padding: 10px 15px;
    margin-right: 30px;
  }
  .userBtnCancel {
    color: #54698d;
    font-weight: 700;
    text-decoration: none;
    border-bottom: 1px solid #54698d;
  }
}
</style>